export default __webpack_public_path__ + "static/media/bamboo.5fa08aef.png";